import axios from '../../../utils/API';

// PROFIL CUSTOMERS API calls
// ------------------------------------------------------------------------------------------------
// CLOSE API
export async function getCustomers(dataDB) {
    return await axios.get('/pantheon/subject', { params: dataDB })
}

export async function getOrdersPantheon(dataDB) {
    return await axios.get('/pantheon/order', { params: dataDB })
}

export async function postOrdersPantheon(dataDB) {
    return await axios.post('/pantheon/order', dataDB )
}

export async function postOrderItemPantheon(dataDB) {
    return await axios.post('/pantheon/orderitems', dataDB )
}

export async function getStockPantheon(dataDB) {
    return await axios.get('/pantheon/stock', { params: dataDB })
}

export async function getPostPantheon(dataDB) {
    return await axios.get('/pantheon/postcode', { params: dataDB })
}

export async function sendPdf(acKey, email, alternateEmail, reminder) {
    if(alternateEmail) return await axios.get('/pantheon/send_pdf?acKey='+encodeURIComponent(acKey)+'&email='+encodeURIComponent(email)+'&email='+encodeURIComponent(alternateEmail)+'&reminder='+encodeURIComponent(reminder))
    return await axios.get('/pantheon/send_pdf?acKey='+encodeURIComponent(acKey)+'&email='+encodeURIComponent(email)+'&reminder='+encodeURIComponent(reminder))
}

export async function getPdf(dataDB) {
    return await axios.get('/pantheon/pdf', { params: dataDB })
}

export async function getPdfUuid(dataDB) {
    return await axios.get('/pantheon/generate_pdf_uuid', { params: dataDB })
}

export async function stornoOrderPantheon(dataDB) {
    return await axios.post('/pantheon/cancellation', dataDB )
}

export async function reservOrderPantheon(dataDB) {
    return await axios.post('/pantheon/reserve', dataDB )
}

export async function otpremnicaOrderPantheon(dataDB) {
    return await axios.post('/pantheon/dispatch', dataDB )
}

export async function sendPdfWapp(dataDB) {
    return await axios.get('/pantheon/send_pdf_wa', { params: dataDB })
}

export async function processExternalOrder(dataDB) {
    return await axios.post('/pantheon/external-orders/process', dataDB)
}

export async function getPosAdminMe() {
    return await axios.get('/pantheon/external-orders/admin/me')
}

export async function getPosOrdersAdmin(dataDB) {
    return await axios.get('/pantheon/external-orders/admin/list', { params: dataDB })
}

export async function resetPosOrder(dataDB) {
    return await axios.post('/pantheon/external-orders/admin/reset', dataDB)
}